export const QUOTE_STATUSES = [
  { key: "draft", en: "Draft", zh: "草稿", badge: "border-slate-600 text-slate-300 bg-slate-800/60", active: "data-[on=true]:bg-slate-600 data-[on=true]:text-white" },
  { key: "approved", en: "Approved", zh: "已确认", badge: "border-sky-500/50 text-sky-300 bg-sky-500/10", active: "data-[on=true]:bg-sky-500 data-[on=true]:text-white" },
  { key: "paid", en: "Paid", zh: "已付款", badge: "border-emerald-500/50 text-emerald-300 bg-emerald-500/10", active: "data-[on=true]:bg-emerald-500 data-[on=true]:text-slate-950" },
];

export const statusOf = (qt) => QUOTE_STATUSES.find((s) => s.key === (qt.status || "draft")) || QUOTE_STATUSES[0];

// Approved + vehicle still in the workshop → shown in red and sorted to the top of the Activity log
export const ONGOING = { key: "ongoing", en: "Ongoing", zh: "进行中", badge: "border-rose-500/60 text-rose-200 bg-rose-500/15" };
export const isOngoing = (qt) => !!qt.ongoing && (qt.status || "draft") === "approved";
export const sortOngoingFirst = (list) => [...list].sort((a, b) => Number(isOngoing(b)) - Number(isOngoing(a)));

export const isEditableDraft = (qt) => (qt.status || "draft") === "draft" && !qt.invoice_no && !qt.invoice_id;

// /quote?edit=… keeps the customer link so the fleet banner shows while editing
export const editDraftUrl = (qt) => {
  const p = new URLSearchParams({ edit: qt.id });
  if (qt.customer_id) p.set("customer", qt.customer_id);
  if (qt.vehicle_id) p.set("vehicle", qt.vehicle_id);
  return `/quote?${p.toString()}`;
};
